import { ReactNode, useRef } from "react";
import { Box } from "@xcorejs/ui";
import { SubHeaderContent, SubHeaderContentsRes } from "pages/api/robe/subheader";
import { useLayout } from "xcore";
import { ContentLink } from "@robe/client";

interface SubheaderItemProps {
  children: ReactNode;
  set: () => void;
  isActiveItem: boolean;
  content: SubHeaderContent;
}

const SubheaderItem = ({ isActiveItem, set, children, content, ...props }: SubheaderItemProps) => {
  const { localize } = useLayout();
  const state = useRef(false);

  const items = localize((content?.values as any).itemsRelation) as SubHeaderContentsRes | null;
  const itemsFiltered = items ? items.filter((item) => item && item?.id && item?.type && item?.slug && item?.values) : [];

  const p = {
    variant: "simple",
    ...DefaultSubheaderNavLinkStyle,
    whiteSpace: "nowrap",
    position: "relative",
    cursor: "pointer",

    // Set active item initially onClick, afterwards onMouseEnter
    onClick: () => {
      state.current = true;
      setTimeout(() => state.current && set(), 200);
    },
    // Only set the state onMouseEnter if initial onClick on any subheader item was fired
    onMouseEnter: () => {
      if (isActiveItem) {
        state.current = true;
        setTimeout(() => state.current && set(), 200);
      }
    },
    onMouseLeave: () => {
      state.current = false;
    },
    ...props,
  } as const;

  // If POP has no items consider the subheader item as a link to POP
  return (
    <Box {...p}>
      {itemsFiltered.length > 0 ? (
        children
      ) : (
        <ContentLink noUILink content={content}>
          {children}
        </ContentLink>
      )}
    </Box>
  );
};

export default SubheaderItem;

export const DefaultSubheaderNavLinkStyle = {
  display: "flex",
  alignItems: "center",
  fontFamily: "avenir",
  fontSize: { _: "1.2rem", lg: "1.4rem" },
  padding: { _: "0 1rem", md: "0 1.2rem", xl: "0 2rem" },
  height: "4.6rem",
  fontWeight: 500,
  lineHeight: "2.1rem",
  color: "lightGray !important",
  bg: "none !important",
  transition: "color 300ms, background 300ms",
  textAlign: "center" as const,
  _hover: {
    background: "white !important",
    color: "#1e1e1e !important",
    zIndex: 10,
  },
};

export const DefaultSubheaderActiveNavLinkStyle = {
  bg: "#fff !important",
  color: "#1e1e1e !important",
};
